import {
  mapLoginLookupResponse,
  type LoginLookupResponse,
  type LoginLookupResult,
} from "./loginLookup";

export function createLoginMethodLookup(authApiBaseUrl: string) {
  return async (email: string): Promise<LoginLookupResult> => {
    if (!authApiBaseUrl) {
      return { authType: "basic" };
    }

    const response = await fetch(`${authApiBaseUrl}/user/usertype`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_email: email }),
    });

    if (response.status === 404) {
      return { authType: "basic" };
    }

    if (!response.ok) {
      throw new Error(`Auth lookup failed with ${response.status}`);
    }

    return mapLoginLookupResponse(
      (await response.json()) as LoginLookupResponse,
    );
  };
}
